module.exports = __webpack_public_path__ + "static/media/13.3f1453cf.jpg";